import React from "react";
import ReactDOM from "react-dom";

import CommentsContainer from "./components/CommentsContainer";

import "./comments.scss";

const container = document.querySelector("[data-comments]");

if (container) {
  const { commentId, commentRules, open, hideButton } = container.dataset;

  ReactDOM.render(
    <CommentsContainer
      uuid={commentId}
      rules={commentRules}
      open={open && open === "true"}
      hideButton={hideButton && hideButton === "true"}
    />,
    container
  );
}
